import { __assign } from "tslib";
import dayjs from 'dayjs';
/**
 * @description 获取日期所在月的号列表网格数据
 * @param {string} dateStr 日期字符串，YYYY-MM-DD
 * @returns {object} {
 *  year: 年,
 *  month: 月,
 *  weekList: [
 *    {
 *      value: 日期值, YYYY-MM-DD,
 *      valueOf: 时间戳，毫秒
 *      isBefore: 当前日期之前,
 *      isAfter: 当前日期之后
 *      isSameDate: 同一天
 *      isSameMonth: 同月,
 *      isToday: 今天
 *    }
 *  ]
 * }
 */
export default function getDayGrids(dateStr) {
    var dateMonent = dayjs(dateStr);
    var dateObj = {
        year: dateMonent.year(),
        month: dateMonent.month() + 1,
    };
    // 二维日期集合， [周[天]]
    var weekList = [];
    // 月份第一天
    var firstMonent = dateMonent.clone().startOf('month');
    var firstWeekDay = firstMonent.day();
    // 月份最后一天
    var lastMonent = dateMonent.clone().endOf('month');
    var lastWeekDay = lastMonent.day();
    // 当月的天数
    var dayCount = dateMonent.daysInMonth();
    // 1号不是周日，补齐欠缺
    dayCount += firstWeekDay;
    // 月末不是周六，补齐欠缺
    dayCount += 6 - lastWeekDay;
    var todayMonent = dayjs().startOf('day');
    var nextYearTodayMonent = todayMonent.clone().add(1, 'years');
    for (var i = 0; i < dayCount; i++) {
        var index = Math.floor(i / 7);
        var curMonent = null;
        if (firstWeekDay <= 6) {
            curMonent = firstMonent.clone().add(i - firstWeekDay, 'days');
        }
        else {
            curMonent = firstMonent.clone().add(i, 'days');
        }
        var curDate = {
            value: curMonent.format('YYYY-MM-DD'),
            day: curMonent.get('date'),
            valueOf: curMonent.valueOf(),
            unix: curMonent.unix(),
            isBefore: curMonent.isBefore(todayMonent),
            isAfter: curMonent.isAfter(todayMonent),
            isSameDate: curMonent.isSame(dateMonent),
            isSameMonth: curMonent.isSame(dateMonent, 'month'),
            isAfterNextYearToday: curMonent.isAfter(nextYearTodayMonent),
            isToday: curMonent.format('YYYY-MM-DD') === todayMonent.format('YYYY-MM-DD'),
        };
        if (!weekList[index])
            weekList[index] = [curDate];
        else
            weekList[index].push(curDate);
    }
    return __assign(__assign({}, dateObj), { weekList: weekList });
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/date/getDayGrids.js
// module id = null
// module chunks = 